// extracted by mini-css-extract-plugin
module.exports = {"root":"SubscriptionAdviceBanner_root__11oyJ","text":"SubscriptionAdviceBanner_text__22eBm","button":"SubscriptionAdviceBanner_button__NQOcE"};